import { RelationType } from '../enum/relation-type.enum';
import { SavedLink } from '../saved/saved-link.type';
import { ToCreateLink } from '../to-create/to-create-link.type';
import { DoubleTableTitle } from '../type/double-table-title.type';

export class Link {
  private _id?: number;
  private _table1Name: string;
  private _table2Name: string;
  private _action: string;
  private _relationship: RelationType;
  private _databaseModelId?: number;

  constructor(tables: DoubleTableTitle, action: string, relationship: RelationType) {
    this._table1Name = tables.table1;
    this._table2Name = tables.table2;
    this._action = action;
    this._relationship = relationship;
  }

  public static mapFromSaved(dto: SavedLink): Link {
    const tables: DoubleTableTitle = {
      table1: dto.table1,
      table2: dto.table2,
    };
    const link = new Link(tables, dto.action, dto.relationship);
    link._id = dto.id;
    link._databaseModelId = dto.databaseModelId;
    return link;
  }

  public static mapToSaved(link: Link): SavedLink {
    return {
      id: link._id as number,
      table1: link._table1Name,
      table2: link._table2Name,
      action: link._action,
      relationship: link._relationship,
      databaseModelId: link._databaseModelId as number,
    };
  }

  public static mapToToCreate(link: Link): ToCreateLink {
    return {
      table1: link._table1Name,
      table2: link._table2Name,
      action: link._action,
      relationship: link._relationship,
    };
  }

  get id(): number | undefined {
    return this._id;
  }

  setId(id: number): Link {
    this._id = id;
    return this;
  }

  get databaseModelId(): number | undefined {
    return this._databaseModelId;
  }

  setDatabaseModelId(id: number | undefined): Link {
    this._databaseModelId = id;
    return this;
  }

  /**
   * used for debug
   */
  toString(): string {
    return `Link : ${this._table1Name} - ${this._table2Name}`;
  }

  get table1(): string {
    return this._table1Name;
  }

  get table2(): string {
    return this._table2Name;
  }

  computeTranslatedSentence(isEnglish: boolean): string {
    switch (this._relationship) {
      case RelationType.OneToOne:
        return isEnglish ? `One ${this.table1} ${this._action} one ${this.table2}` : `Un(e) ${this.table1} ${this._action} un(e) ${this.table2}`;
      case RelationType.OneToMany:
        return isEnglish ? `One ${this.table1} ${this._action} many ${this.table2}` : `Un(e) ${this.table1} ${this._action} plusieurs ${this.table2}`;
      case RelationType.ManyToOne:
        return isEnglish ? `Many ${this.table1} ${this._action} one ${this.table2}` : `Plusieurs ${this.table1} ${this._action} un(e) ${this.table2}`;
      case RelationType.ManyToMany:
        return isEnglish
          ? `One ${this.table1} ${this._action} many ${this.table2}
        and one ${this.table2} is ${this._action} by many ${this.table1}`
          : `Un(e) ${this.table1} ${this._action} plusieurs ${this.table2}
        et plusieurs ${this.table2} sont ${this._action} par un(e) ${this.table1}`;
      default:
        throw new Error();
    }
  }
}
